import { Box, Container, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { theme } from '../../App';
import { NAVBAR_SPACE } from '../Navbar/Navbar';
import ImageDialog from '../ImageDialog/ImageDialog';

export default function AppOffers({ appPageData, title = "Aplikace nabízí:", wrap = 900 }) {
    const tablet = useMediaQuery("(max-width:1050px)");

    const textSize = tablet ? "100%" : "420px";

    return (
        <Container maxWidth='lg' sx={{ py: { xs: '40px', sm: '40px', md: '80px' }, px: NAVBAR_SPACE }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: tablet ? 'wrap' : 'nowrap' }}>
                <Box sx={{ textAlign: 'left', minWidth: textSize, maxWidth: textSize }}>
                    <Typography variant='big' sx={{ mb: '40px' }}>{title}</Typography>
                    <Box component={'ol'} sx={{ pl: '20px', fontWeight: 'bold', maxWidth: tablet ? '100%' : '400px', }} >
                        {appPageData.offers.map((t, i) => <li key={"Offer" + i}><Typography sx={{ ml: '5px', mb: '5px' }}>{t}</Typography></li>)}
                    </Box>
                </Box>
                <Box sx={{ mt: tablet ? '60px' : '0px', pl: { md: '20px', lg: '48px' }, ml: 'auto', display: 'flex', position: 'relative', justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
                    <ImageDialog>
                        {<picture>
                            <source srcSet={appPageData.offersImage} type="image/webp" />
                            <Box
                                component="img"
                                alt="Ukázka"
                                src={appPageData.offersImage}
                                sx={[
                                    {
                                        height: 'auto',
                                        width: '100%',
                                        /*transform: "rotate(0deg)",
                                        transitionDuration: "200ms",
                                        '&:hover': {
                                            transform: "rotate(5deg)",
                                        }*/
                                    },

                                ]}
                            />
                        </picture>}
                    </ImageDialog>
                </Box>
            </Box>
        </Container>

    )
}
